var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackdrop5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 813,
    height: 571,
    viewBox: "0 0 813 571",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2244_34947)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M557.902 255.91L255 296.676L311.829 315.349L557.902 255.91Z",
    fill: "#FCD535"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2244_34947",
    x: 0,
    y: 0.909546,
    width: 812.902,
    height: 569.44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 127.5,
    result: "effect1_foregroundBlur_2244_34947"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackdrop5);
export default __webpack_public_path__ + "static/media/backdrop5.5de28b4f5b03e8902090759f19d307d2.svg";
export { ForwardRef as ReactComponent };